html {
  --logo-animation-delay: 0.2s;
  --msg-arrow-size: 15px;
  --msg-padding: 6px;
}

main {
  flex-grow: 100;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  padding: 0px;
  margin: 0px;
}

.user-count {
  color: var(--color-accent);
  display: flex;
  flex-direction: row;
  margin: 0px 1rem;
}
.user-count span {
  font-weight: bold;
  margin: 0.2em;
  font-size: 1.6rem;
}
.user-count svg {
  width: 1.1em;
}

#botbar {
  background: var(--color-base01);
  display: flex;
  flex-direction: row;

  background-color: var(--color-base02);

  border: solid var(--color-base03) var(--border-size);
  border-radius: 25px;

  margin: 0px 20px 20px 20px;

  box-shadow: 0px 0px 15px var(--color-base00);
}

#botbar:has(#send-input:focus-visible) {
  outline: 2px ridge var(--color-accent);
}

#send-input {
  flex-grow: 1;
  overflow: auto;
  flex-grow: 80;
  resize: none;
  border: none;
  margin: 0px;
  font-size: 1em;
  font-family: inherit;
  color: var(--color-text);
  padding: 1rem 1.5rem;

  max-height: 300px;
}
#send-input:focus-visible {
  outline: none !important;
}

#sendbtn {
  padding: 0em 2em;
  background: var(--color-base02);
}
#sendbtn:hover {
  background: var(--color-base03);
}

a.goto-chat-link {
  text-align: center;
  font-weight: bold;
  text-decoration-thickness: 2px;
}

.chat-name {
  margin: 0px;
  flex-grow: 0;
}

.text-accent {
  color: var(--color-accent);
}

#connectbtn {
  border-radius: 1000px;
}
#connectbtn:hover {
  background: var(--color-base03);
}

#err-mesg {
  margin-top: 1rem;
  font-weight: bold;
  text-align: center;
}
.err {
  color: var(--color-error);
}
.info {
  color: var(--color-accent);
}

#chat {
  position: absolute;
  display: flex;
  flex-direction: column;
  left: 0px;
  right: 0px;
  top: 0px;
  bottom: 0px;
  margin: 0px;
  padding: 0px;
  overflow: hidden;
}
#mesgs {
  flex-grow: 1000;
  padding: 10px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  scroll-behavior: smooth;
}
@keyframes message_slide {
  0% {
    transform: translateX(-100%) scale(0.4);
  }
  100% {
    transform: translateX(0%) scale(1);
  }
}
.message {
  animation: message_slide 0.3s ease-in-out;
  padding: var(--msg-padding);
  background-color: var(--color-base01);
  border: solid 2px var(--color-base02);
  border-radius: 10px;
  border-top-left-radius: 0px;

  margin: 0px 0px 20px 10px;
  align-self: start;
  max-width: calc(100% - 25px);
  display: flex;
  flex-direction: column;
}
.message_top {
  display: flex;
  flex-direction: row;
  margin-bottom: 0.4em;
}
.timestamp {
  margin-left: auto;
  padding-left: 0.6rem;
  font-weight: bold;
  font-size: 0.6em;
  opacity: 0.6;
  color: var(--color-text);
}

.msg_arrow {
  position: relative;
  left: calc(0px - var(--msg-padding) - var(--msg-arrow-size));
  top: calc(-2.5px - var(--msg-padding));
  fill: var(--color-base01);
  stroke: var(--color-base02);
  stroke-width: 0.6;
  stroke-linejoin: round;
  width: var(--msg-arrow-size);
}
.user {
  font-weight: bold;
  font-size: 0.8em;
  margin-bottom: 2px;
}

.role {
  font-size: 0.8em;
  font-family: inherit;
  text-transform: uppercase;
  opacity: 0.6;
  font-weight: bold;
}
.role:not(:empty) {
  margin-left: 0.6rem;
  background: var(--color-base02);
  border: solid var(--color-base03) 2px;
  border-radius: 10000px;
  padding: 0px 3px;
}
.mod-badge {
  opacity: 1;
  color: var(--color-accent);
  border-color: var(--color-accent);
}
.user_content {
  margin-top: calc(0px - var(--msg-arrow-size));
  max-width: 100%;
  display: flex;
  flex-direction: column;
}
.content {
  white-space: pre-line;
  word-wrap: break-word;
  display: inline-block; /* Add this */
  max-width: 100%; /* Ensure it respects parent width */
}
.message-actions {
  display: flex;
  flex-direction: row;
  justify-content: end;
}
.message-actions > * {
  font-size: 0.8em;
  margin: 0px;
}

#profwarn-dialog {
  max-width: 600px;
  display: flex;
  flex-direction: column;
}
